import d from "../../node_modules/classnames/index.js";
import { useFormContext as v, Controller as M } from "../../node_modules/react-hook-form/dist/index.esm.js";
import N from "../../node_modules/react-input-mask/index.js";
import "../../UI/style.js";
import "../../UI/FormGrid/formGrid2.js";
import { jsx as o, jsxs as j, Fragment as k } from "../../_virtual/jsx-runtime.js";
import { UIInputContainer as B } from "../../UI/FormGrid/InputContainer.js";
import { UIInputText as U } from "../../UI/Input/UIInputText.js";
import "../../UI/Input/UIInputDate.js";
import "../../UI/Input/UIInputCheckbox.js";
import "../../UI/Input/UIInputFile.js";
import "../../UI/Input/UIInputTextArea.js";
import "../../UI/Blocks/Button/Button.js";
import "../../UI/Blocks/Emphasis/emphasis2.js";
import "../../UI/Blocks/Card/card2.js";
import "react";
import "../../UI/Blocks/Toaster/toast2.js";
import "../../UI/Blocks/Toaster/toaster2.js";
import "../../UI/Input/UIInputText2.js";
import { AutoCompleteDialog as z } from "../Utils/AutoCompleteDialog.js";
function Y({
  name: a,
  onChange: e,
  label: n,
  className: p,
  required: s,
  variant: m = "medium",
  disabled: u,
  alwaysShowMask: l,
  mask: c,
  maskPlaceholder: g = "",
  placeholder: F,
  autoComplete: i
}) {
  const {
    control: I,
    setFocus: h,
    setValue: x,
    trigger: f
  } = v();
  return /* @__PURE__ */ o(M, {
    name: a,
    control: I,
    render: ({
      field: t,
      fieldState: {
        error: r,
        isTouched: C
      }
    }) => /* @__PURE__ */ o(B, {
      size: m,
      name: t.name,
      label: n,
      required: s,
      errorMessage: r == null ? void 0 : r.message,
      children: /* @__PURE__ */ j(k, {
        children: [/* @__PURE__ */ o(
          N,
          {
            placeholder: F,
            alwaysShowMask: l,
            mask: c,
            maskPlaceholder: g,
            onChange: e ? (V) => e(V.target.value, C) : t.onChange,
            onBlur: t.onBlur,
            disabled: u,
            value: t.value || "",
            name: t.name,
            children: /* @__PURE__ */ o(U, {
              variant: m,
              ref: t.ref,
              hasError: !!r,
              className: d(p)
            })
          }
        ), i && /* @__PURE__ */ o(z, {
          sourceValue: t.value,
          inputName: t.name,
          setFieldFocus: h,
          setFieldValue: x,
          triggerFieldValidation: f,
          ...i
        })]
      })
    })
  });
}
export {
  Y as InputMask
};
//# sourceMappingURL=InputMask.js.map
